import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_down_blue",
  "use": "arrow_down_blue-usage",
  "viewBox": "0 0 1920 1080",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 1080\" id=\"arrow_down_blue\">\n  <!-- Generator: Adobe Illustrator 30.2.1, SVG Export Plug-In . SVG Version: 2.1.1 Build 1)  -->\n  <defs>\n    <style>\n      #arrow_down_blue .st0 {\n        fill: #017aa5;\n      }\n    </style>\n  </defs>\n  <polygon class=\"st0\" points=\"363.11 363.11 726.22 0 0 0 363.11 363.11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol